import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-stoks',
  standalone: false,
  templateUrl: './stoks.component.html',
  styleUrl: './stoks.component.scss'
})

export class StoksComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  statut: any = '';
  isDisabled: boolean = false;
  hasError = false;
  errorMessage = '';
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalContent1') modalContent1: TemplateRef<any>;
  detailsItems: any
  membreItems: any = [];
  ProduitItems: any = [];
  filteredCooperatives: any[] = [];
  selectedCooperative: string = '';
  selectedProduit: string = '';
  cooperativeItems: any = [];

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private FecthDataService: FecthDataService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private paramService: ParameterService,
  ) {
    console.log(" this.localstorage.getUsers().data", this.localstorage.getUsers().data);

    this.user_reference = this.localstorage.getUsers().data.reference
    this.getStocks();
  }

  getStocks() {
    this.isLoading = true;
    this.hasError = false;

    const requestData = {
      user_id: this.user_reference,
   //   cooperative_id: this.user_reference = this.localstorage.getUsers().data.cooperative.reference

    }
    this.paramService.getStock(requestData).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.updatePaginated();
        this.getProduit()
        //console.log("la reponse du webservice", this.items);

      },
      (error) => {
        //console.log("une erreu est survenu", error);
        this.isLoading = false;
        this.hasError = true;
        this.errorMessage = 'Impossible de charger les données';
      }
    )
  }
  getProduit() {
    this.isLoading = true;
    this.hasError = false;

    this.paramService.getParametrageProduit().subscribe(
      (response: any) => {
        this.isLoading = false;
        this.ProduitItems = response.data;
        this.getCooperative();
        //console.log("la reponse du webservice", this.items);

      },
      (error) => {
        console.log("une erreu est survenu", error);
      }
    )
  }
  getCooperative() {
    this.isLoading = true;
    this.hasError = false;

    this.paramService.getCooperative().subscribe(
      (response: any) => {
        this.isLoading = false;
        this.cooperativeItems = response.data;

        //console.log("la reponse du webservice", this.items);

      },
      (error) => {
        console.log("une erreu est survenu", error);

      }
    )
  }
  filterMembres() {
    if (!this.selectedCooperative) {
      this.filteredtems = this.items;
    } else {
      this.filteredtems = this.items.filter(member =>
        member.cooperative?.id === +this.selectedCooperative
      );
    }
    this.first = 0; // Réinitialisation de la pagination après le filtrage
    this.updatePaginated();
  }

  filterByName() {
    if (!this.searchTerm) {
      this.filteredtems = this.items; // Affiche tous les éléments si la recherche est vide
    } else {
      this.filteredtems = this.items.filter(stock =>
        `${stock?.membre?.nom} ${stock?.membre?.prenom}`.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }
    this.updatePaginated();
  }

  filterByProduit() {
    if (!this.selectedProduit) {
      this.filteredtems = this.items; // Affiche tous les éléments si aucun produit n'est sélectionné
    } else {
      this.filteredtems = this.items.filter(stock =>
        stock?.produit?.id === +this.selectedProduit
      );
    }
    this.updatePaginated();
  }

  filterByCooperative() {
    if (!this.selectedCooperative) {
      this.filteredtems = this.items; // Affiche tous les éléments si aucune coopérative n'est sélectionnée
    } else {
      this.filteredtems = this.items.filter(stock =>
        stock?.membre?.cooperative?.id === +this.selectedCooperative
      );
    }
    this.updatePaginated();
  }

  onPageChange(event) {
    this.first = event.first; // Mise à jour de la page actuelle
    this.rows = event.rows; // Mise à jour de la page actuelle
    this.updatePaginated();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }


  openModal(item: any) {
    this.detailsItems = item
    console.log("this.detailsItems", this.detailsItems);

    this.modalService.open(this.modalContent1, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }

}